import { Tooltip, Stack } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EllipsisText from "components/EllipsisText";

const formatDate = (dateStr) => dateStr?.split("T")?.[0] ?? dateStr;

export const createLandingPagesListColumns = ({ onDetailClick }) => {
  return [

    {
      name: "Campaign",
      cell: (row) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <CampaignOutlinedIcon style={{ color: "#222" }} />
          <EllipsisText text={row.name} width="150px" />
        </Stack>
      ),
      sortable: true,
      minWidth: "200px",
    },

    {
      name: "Date",
      cell: (row) => {

        const dateOnly = formatDate(row.created_at);
        return (
          <Stack direction="row" alignItems="center" spacing={1}>
            <CalendarMonthOutlinedIcon style={{ color: "#666" }} />
            <span>{dateOnly}</span>
          </Stack>
        );
      },
      sortable: true,
      minWidth: "140px",
    },

    {
      name: "Views",
      cell: (row) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <VisibilityOutlinedIcon style={{ color: "#666" }} />
          <strong>{Number(row.total_visit).toLocaleString()}</strong>
        </Stack>
      ),
      sortable: true,
      right: true,
      minWidth: "120px",
    },

  ];
};
